"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/getPrototypeOf"));

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var IpcBroadcastChannel = /*#__PURE__*/function (_EventEmitter) {
  (0, _inherits2.default)(IpcBroadcastChannel, _EventEmitter);

  var _super = _createSuper(IpcBroadcastChannel);

  function IpcBroadcastChannel() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, IpcBroadcastChannel);
    _this = _super.call(this);
    _this.bc = new BroadcastChannel('kiwi-ipc');
    _this.bc.onmessage = (0, _bind.default)(_context = _this.onmessage).call(_context, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(IpcBroadcastChannel, [{
    key: "send",
    value: function send(msg) {
      if (this.bc) {
        this.bc.postMessage(msg);
      }
    }
  }, {
    key: "onmessage",
    value: function onmessage(msg) {
      this.emit('message', msg);
    }
  }]);
  return IpcBroadcastChannel;
}(_eventemitter.default);

var IpcLocalStorage = /*#__PURE__*/function (_EventEmitter2) {
  (0, _inherits2.default)(IpcLocalStorage, _EventEmitter2);

  var _super2 = _createSuper(IpcLocalStorage);

  function IpcLocalStorage() {
    var _context2;

    var _this2;

    (0, _classCallCheck2.default)(this, IpcLocalStorage);
    _this2 = _super2.call(this);
    window.addEventListener('storage', (0, _bind.default)(_context2 = _this2.onmessage).call(_context2, (0, _assertThisInitialized2.default)(_this2)));
    return _this2;
  }

  (0, _createClass2.default)(IpcLocalStorage, [{
    key: "send",
    value: function send(msg) {
      localStorage.setItem('kiwi-ipc', (0, _stringify.default)(msg));
      localStorage.removeItem('kiwi-ipc');
    }
  }, {
    key: "onmessage",
    value: function onmessage(msg) {
      if (msg.key === 'kiwi-ipc' && msg.newValue) {
        try {
          var parsedMsg = {
            data: JSON.parse(msg.newValue)
          };
          this.emit('message', parsedMsg);
        } catch (e) {
          this.emit('error');
        }
      }
    }
  }]);
  return IpcLocalStorage;
}(_eventemitter.default);

var _default = window.BroadcastChannel ? new IpcBroadcastChannel() : new IpcLocalStorage();

exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IPC"]
window._kiwi_exports.libs.IPC = exports.default ? exports.default : exports;
